import React, { useEffect } from 'react';
import Navbar from "../../components/Navbar/Navbar";
import Footer from '../../components/Footer/Footer';
import BackToTop from '../../components/BackToTop/BackToTop';
import PageHeader from "../../components/PageHeader/PageHeader";
import './About.css';

// Assets
import founderImg from '../../assets/images/president/presi.jpeg';
import hortiImg from '../../assets/images/programs/horticulture/pic3.png';
import maizeImg from '../../assets/images/programs/training/maize.png';

export default function About() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="about-page">
            <Navbar />
            <PageHeader title="About Showbouys Foundation LBG" path="/about" name="About Us" backgroundImage={maizeImg} />
            
            <section className="about-intro py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="about-history-content">
                                <span className="pill-title">&bull; OUR HISTORY</span>
                                <h2 className="section-title">A Journey Rooted in Passion & Education</h2>
                                <p>Founded by <strong>Mr. Isaac Agyiri</strong>, Showbouys Foundation LBG was born out of a profound commitment to revolutionizing agriculture in Ghana. With years of experience as an educator and a deep passion for the soil, Mr. Agyiri recognized a critical gap: the need for technical, sustainable farming practices that could empower the next generation.</p>
                                <p>The foundation started as a small-scale community initiative, focusing on providing hands-on training to local youth. Today, it has grown into a leading force for regenerative agriculture, partnering with national leadership and international experts to drive systemic change across rural communities.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-image-stack">
                                <img src={founderImg} alt="Founder Mr. Isaac Agyiri" className="img-fluid rounded main-img" />
                                <div className="experience-badge">
                                    <h3>Best Teacher</h3>
                                    <p>Overall Best Agriculture Teacher Award Winner</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mission-vision-section py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="mission-card">
                                <div className="icon-circle">
                                    <i className="fas fa-bullseye"></i>
                                </div>
                                <h3>Our Mission</h3>
                                <p>To empower youth and rural communities through advanced technical training in regenerative agriculture, environmental stewardship, and agribusiness innovation, ensuring a sustainable and food-secure future for all.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="vision-card">
                                <div className="icon-circle">
                                    <i className="fas fa-eye"></i>
                                </div>
                                <h3>Our Vision</h3>
                                <p>To be the premier center for agricultural excellence in West Africa, where innovation meets tradition to create resilient, self-sufficient communities and a protected planet.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="values-section py-5 bg-light">
                <div className="container text-center">
                    <span className="pill-title">&bull; OUR VALUES</span>
                    <h2 className="section-title mb-5">The Principles That Guide Us</h2>
                    <div className="row">
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="value-item">
                                <h4>Sustainability</h4>
                                <p>We practice and teach methods that restore the earth rather than depleting it.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="value-item">
                                <h4>Innovation</h4>
                                <p>Integrating global best practices, like Dutch horticulture, with local wisdom.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="value-item">
                                <h4>Integrity</h4>
                                <p>Transparency and accountability in every community partnership and project.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="value-item">
                                <h4>Community</h4>
                                <p>We are stronger together. Our impact is built on collective effort and mentorship.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="impact-cta-section py-5 text-white" style={{backgroundImage: `linear-gradient(rgba(47, 95, 168, 0.9), rgba(47, 95, 168, 0.9)), url(${hortiImg})`, backgroundSize: 'cover', backgroundPosition: 'center'}}>
                <div className="container text-center py-4">
                    <h2 className="display-4 font-weight-bold mb-4" style={{fontFamily: 'Cormorant Garamond, serif'}}>Ready to grow with us?</h2>
                    <p className="lead mb-5">Join our mission to transform lives through sustainable agriculture and education.</p>
                    <div className="d-flex justify-content-center gap-3 flex-wrap">
                        <a href="/contact" className="btn btn-custom px-5">Volunteer Now</a>
                        <a href="/donate" className="btn btn-outline-light px-5 py-3 rounded-pill font-weight-bold ml-3" style={{border: '2px solid white'}}>Donate Now</a>
                    </div>
                </div>
            </section>

            <Footer />
            <BackToTop />
        </div>
    );
}